<!--心电图（可选）-->
<script setup>
import { ref,reactive, onMounted, computed } from "vue";
import { useCrfStore } from "@/stores/crf";
// import { Upload } from "@element-plus/icons-vue/dist/types";
import upload from "@/components/upload1.vue"
// import upload from "@/cmom"
import check from "./check.vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});
// let show = ref(false)
// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// onMounted(() => {
  // console.log(model.fields[props.type], props.type);
  // model.fields?.[props.type]?.心电图 ||= "未测";
// });

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  // if(model.fields[props.type]) console.log(model.fields[props.type], props.type,'我是新稻田')
  return model.fields[props.type];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <div style="display:flex;">
      <h2>心电图（可选）</h2>
      <upload :type="props.type" :data="model" name="xdt"></upload>
      <check :period="props.type" text="心电图（可选）" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
      <el-form-item label="心电图是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['心电图是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['心电图是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增心电图（可选）':'心电图（可选）'"  v-if="crfFields && notScreen" class="redStar">
            <el-radio-group v-if="notScreen" v-model="crfFields['是否新增心电图']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="否" prop="否"></el-radio>
            </el-radio-group>

        </el-form-item>
        
        <template v-if="crfFields['是否新增心电图'] == '是' || !notScreen">
          <el-form-item label="心电图" class="not_redStar" :prop="itemProp(`心电图`)" :rules="crfStore.radioRules(`心电图`)">
            <el-radio-group v-model="crfFields['心电图']">
              <el-radio label="正常" prop="正常"></el-radio>
              <el-radio label="异常" prop="异常"></el-radio>
              <el-radio label="未测" prop="未测"></el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
      </template>

  </template>
</template>

<style lang="scss" scoped>
</style>